/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LeadCommentReaction } from './LeadCommentReaction';
import {
    LeadCommentReactionFromJSON,
    LeadCommentReactionFromJSONTyped,
    LeadCommentReactionToJSON,
    LeadCommentReactionToJSONTyped,
} from './LeadCommentReaction';

/**
 * 
 * @export
 * @interface CreateOrDeleteLeadCommentReaction200Response
 */
export interface CreateOrDeleteLeadCommentReaction200Response {
    /**
     * 
     */
    data?: LeadCommentReaction;
}

/**
 * Check if a given object implements the CreateOrDeleteLeadCommentReaction200Response interface.
 */
export function instanceOfCreateOrDeleteLeadCommentReaction200Response(value: object): value is CreateOrDeleteLeadCommentReaction200Response {
    return true;
}

export function CreateOrDeleteLeadCommentReaction200ResponseFromJSON(json: any): CreateOrDeleteLeadCommentReaction200Response {
    return CreateOrDeleteLeadCommentReaction200ResponseFromJSONTyped(json, false);
}

export function CreateOrDeleteLeadCommentReaction200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrDeleteLeadCommentReaction200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : LeadCommentReactionFromJSON(json['data']),
    };
}

export function CreateOrDeleteLeadCommentReaction200ResponseToJSON(json: any): CreateOrDeleteLeadCommentReaction200Response {
    return CreateOrDeleteLeadCommentReaction200ResponseToJSONTyped(json, false);
}

export function CreateOrDeleteLeadCommentReaction200ResponseToJSONTyped(value?: CreateOrDeleteLeadCommentReaction200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': LeadCommentReactionToJSON(value['data']),
    };
}

